import React from 'react';
import {Container} from '@mui/material';

import './admin.css';
import {useNavigate} from 'react-router-dom';

interface IPayDebtPage {
    userId: number | null;
}

const AdminPage = (props: IPayDebtPage) => {
    const {userId} = props;

    const navigate = useNavigate();

    setTimeout(() => {
        navigate('/admin/invoices');
    });

    return (
        <Container sx={{pt: 6, pb: 20}} maxWidth="md">
        </Container>
    );
};

export default AdminPage;
